// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__35LKR","footer":"ModalUpdate_footer__1CZgn"};